import Button from "@/lib/components/common/button/button"
import { TextField } from "@mui/material"
import { useCallback, useMemo, useState } from "react"
import * as GraphQLClient from "@apollo/client"
import { MasterUser } from "@/graphql/types"
import { useSnackBar } from "@/lib/ts/hooks/useSnackBar"
import { CreateMasterUser, GetMasterUser } from "@/graphql/documentNode"
import { useQuery } from "react-query"
import { AuthUser } from "aws-amplify/auth"
import styled from "styled-components"
import Parallelogram from "@/lib/components/common/commonIcon/parallelogram"

type Props = {
  setUser: (user: MasterUser | undefined) => void
  setCurrentUser: (currentUser: AuthUser | undefined) => void
  currentUser: AuthUser | undefined
  user: MasterUser | undefined
  signOut: any
}

export const useUserRegistration = (props: Props) => {
  const snackBar1 = useSnackBar({})
  const snackBar2 = useSnackBar({})

  const [inputUserName, setInputUserName] = useState("")
  const [showComponent, setShowComponent] = useState(false)



  const [getMasterUser] = GraphQLClient.useLazyQuery(GetMasterUser, {
    onCompleted: (data) => {
      console.log(data.getMasterUser)
      props.setUser(data.getMasterUser)
      snackBar1.onQuerySuccess()
    },
    onError: (err) => {
      snackBar1.onQueryError()
    },
  })

  const [createMasterUser] = GraphQLClient.useMutation(CreateMasterUser, {
    onCompleted: (data) => {
      console.log(data.createMasterUser)
      props.setUser(data.createMasterUser)
      snackBar2.onMutationSuccess()
    },
    onError: (err) => {
      snackBar2.onMutationError()
    },
  })

  const executeSignOut = useCallback(() => {
    props.setCurrentUser(undefined)
    props.setUser(undefined)
    props.signOut?.()
  }, [props])

  useQuery([props.currentUser], async () => {
    if (props.currentUser && props.currentUser.signInDetails?.loginId) {
      // APIでユーザー取得
      snackBar1.loadStart()
      const result = await getMasterUser({
        variables: {
          email: props.currentUser.signInDetails.loginId,
        }
      })

      // ユーザー登録がなければ作成させる
      if (result.data.getMasterUser === null) {
        console.log("user not exists")
        setShowComponent(true)
      } else {
        console.log("user found")
      }
    }
  })


  const inputUserNameError = useMemo(() => {
    if (!inputUserName) {
      return true
    } else {
      return false
    }
  }, [inputUserName])

  const registerUser = useCallback(async () => {
    snackBar2.loadStart()
    if (inputUserNameError) {
      snackBar2.onMutationError()
      return
    }
    if (!props.currentUser?.signInDetails?.loginId) {
      snackBar2.onMutationError()
      return
    }
    await createMasterUser({
      variables: {
        input: {
          name: inputUserName,
          email: props.currentUser?.signInDetails?.loginId
        }
      }
    })
    setShowComponent(false)
  }, [createMasterUser, inputUserName, inputUserNameError, props.currentUser?.signInDetails?.loginId, snackBar2])



  const registrationComponent = showComponent ? (
    <UserRegistrationStyle>
      <div className="registration-title">
        <p>管理者情報登録</p>
      </div>
      <div className="registration-guide">
        <p>ユーザーネームを設定してください。</p>
      </div>
      <div className="registration-input">
        <TextField
          placeholder="管理者太郎"
          onChange={(event) => { setInputUserName(event.target.value) }}
          error={inputUserNameError}
          helperText={inputUserNameError ? "必須項目です" : ""}
        />
      </div>
      <div>
        <Button
          disabled={inputUserNameError || !props.currentUser?.signInDetails?.loginId}
          buttonType="powerful-red"
          label="登録"
          onClick={registerUser}
        />
      </div>
      {snackBar1.component}
      {snackBar2.component}
    </UserRegistrationStyle>
  ) : (
    <>
      {snackBar1}
      {snackBar2}
    </>
  )

  const userInfoComponent = (
    <UserDataStyle>
      <div className="user-title">
        <Parallelogram
          bodyColor="red"
          shadowColor="white"
        >
          サインイン済
        </Parallelogram>
      </div>
      <div className="user-name">
        {props.user?.name}
      </div>
      <div>
        <Button
          label="サインアウト"
          onClick={props.signOut ? () => { executeSignOut() } : () => { }}
          buttonType="powerful-red-white-shadow"
        />
      </div>
      {snackBar1.component}
      {snackBar2.component}
    </UserDataStyle>
  )

  return {
    registrationComponent,
    showComponent,
    userInfoComponent,
  }
}


const UserRegistrationStyle = styled.div`
  background-color: white;
  color: black;
  width: 360px;
  border-radius: 8px;
  padding: 16px;
  margin: auto;
  .registration-title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 8px;
  }
`

const UserDataStyle = styled.div`
  margin: 0 auto 16px auto;
  padding: 16px;
  border: 3px solid white;
  border-radius: 8px;
  width: 360px;
  text-align: center;
  .user-title {
    margin-bottom: 20px;
  }
  .user-name {
    margin-bottom: 8px;
  }
`